<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <h2 class="mb-25 text-secondary text-lighten-2">
          <span>{{ titles }}</span>
        </h2>
        <h2 class="mb-25">
          {{ values }}
        </h2>
        <span></span><br>
        <b-card-text class="font-small-4">
          <span class="font-weight-bolder">{{ subtitle }}</span><span> {{ link }}</span>
        </b-card-text>
      </div>
      <template v-if="color === 'purple'">
      <b-avatar
        style="background-color: #6A0DAD!important;"
        size="65"
      >
        <feather-icon
          size="30"
          :icon="icon"
        />
      </b-avatar>
      </template>
      <template v-else-if="color === 'blue'">
      <b-avatar
        style="background-color: #1171ef!important;"
        size="65"
      >
        <feather-icon
          size="30"
          :icon="icon"
        />
      </b-avatar>
      </template>
      <template v-else>
        <b-avatar
        :variant="`${color}`"
        size="65"
      >
        <feather-icon
          size="30"
          :icon="icon"
        />
      </b-avatar>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardText, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardText,
    BCardBody,
    BAvatar,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    titles: {
      type: String,
      default: '',
    },
    values: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
